import React from "react";
import styled from "@emotion/styled";

const Tabs = ({ tabs, activeTab, onTabChange, className }) => {
  return (
    <TabWrapper>
      <TabsContainer className={className}>
        {tabs.map((tab, index) => (
          <React.Fragment key={tab.id}>
            <TabItem
              isActive={activeTab === tab.id}
              onClick={() => onTabChange(tab.id)}
            >
              <TabText isActive={activeTab === tab.id}>{tab.label}</TabText>
            </TabItem>
            {index < tabs.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </TabsContainer>
    </TabWrapper>
  );
};
const TabWrapper = styled.div`
  overflow-x: auto; /* Allows scrolling */
  width: 100%;
  max-width: fit-content;
  -webkit-overflow-scrolling: touch; /* Smooth scroll on iOS */
  scrollbar-width: thin; /* For Firefox */
  
  &::-webkit-scrollbar {
    height: 6px; /* Scrollbar height */
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;
const TabsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 8px;
  box-sizing: border-box;
  height: 38px;
   flex-shrink: 0;
`;

const TabItem = styled.button`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  height: 100%;
  background: ${(props) =>
    props.isActive ? "rgb(97, 98, 197)" : "rgb(255, 255, 255)"};
  padding: 12px 16px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
   white-space: nowrap; 

  &:first-of-type {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-of-type {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    background: ${(props) =>
      props.isActive ? "rgb(97, 98, 197)" : "rgb(241, 245, 249)"};
  }
`;

const TabText = styled.span`
  color: ${(props) => (props.isActive ? "white" : "rgb(33, 37, 67)")};
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const Divider = styled.div`
  width: 1px;
  background: linear-gradient(
    -90deg,
    rgba(136, 136, 136, 0.1),
    rgba(136, 136, 136, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  align-self: stretch;
`;

export default Tabs;
